import { Container } from '..';
import { SearchComponent } from '../../components/glucose-db/SearchComponent';
import styles from './HeroSection.module.css';

const cx = (...args: Array<string | false | undefined | null>) =>
  args.filter(Boolean).join(' ');

export const HeroSection_GlucoseDb = ({
  className,
  defaultSearchString,
}: {
  className?: string;
  defaultSearchString?: string;
}) => {
  return (
    <section className={cx(styles.root, className)}>
      <Container className={styles.parentContainer}>
        <div className={styles.content}>
          <div className={styles.headContainer}>
            <h1 className={styles.caption}>OGDb</h1>
            <p className={styles.head}>
              World&apos;s largest
              <br />
              <b>O</b>pen <b>G</b>lucose <b>D</b>ata<b>b</b>ase
            </p>
          </div>
          <SearchComponent defaultSearchString={defaultSearchString} />
        </div>
      </Container>
    </section>
  );
};
